import MExpander from "./MExpander.vue";
export default MExpander;
